<template lang="pug">
.current-fight
  //- ============ CABEÇALHO ============
  header.current-fight__hero
    .current-fight__hero-grid
    .current-fight__hero-glow.current-fight__hero-glow--blue
    .current-fight__hero-glow.current-fight__hero-glow--red
    .current-fight__hero-inner
      p.current-fight__eyebrow
        span.current-fight__eyebrow-pip
        | Julgamento de combate
      h1.current-fight__title Lutando Agora
      .current-fight__hero-meta
        span.current-fight__live
          span.current-fight__live-dot
          | Ao vivo
        span.current-fight__chip(v-if="takeCategory")
          FontAwesomeIcon.current-fight__chip-ic(:icon="['fas','layer-group']")
          | {{ takeCategory }}
        span.current-fight__chip
          FontAwesomeIcon.current-fight__chip-ic(:icon="['fas','list-ol']")
          | Etapa {{ step + 1 }} de {{ stageTotal }} · {{ stageLabel }}

  //- ============ CONTEÚDO ============
  .current-fight__wrap
    //- ----- Estado sem luta carregada -----
    .cf-empty(v-if="!hasFight")
      span.cf-empty__ic 🕹️
      h2.cf-empty__title Nenhuma luta em andamento
      p.cf-empty__text Entre em uma luta pela tela de Lutas para iniciar o julgamento.
      button.btn.btn--solid(@click="$router.push('Fights')")
        FontAwesomeIcon.btn__ic(:icon="['fas','arrow-right']")
        span Ver lutas

    template(v-else)
      //- ----- Confronto -----
      .cf-matchup
        .cf-side.cf-side--blue
          span.cf-side__tag
            FontAwesomeIcon.cf-side__tag-ic(:icon="['fas','robot']")
            | Lado Azul
          .cf-side__media
            img.cf-side__img(v-if="takeBlueRobot.image" :src="takeBlueRobot.image" alt="")
            FontAwesomeIcon.cf-side__ph(v-else :icon="['fas','robot']")
          span.cf-side__name {{ takeBlueRobot.name || 'A definir' }}
          .cf-side__judge(v-if="canCount && step === 1")
            span.cf-side__aggr
              span.cf-side__aggr-k Agressividade
              span.cf-side__aggr-v {{ aggressivityBlue }}
            Select.cf-side__select(
              defaultText="Selecionar Dano"
              :options="takeDamageOptions"
              type='drop'
              @emit="doSetBlueDamage"
            )

        .cf-matchup__vs
          span VS

        .cf-side.cf-side--red
          span.cf-side__tag
            FontAwesomeIcon.cf-side__tag-ic(:icon="['fas','robot']")
            | Lado Vermelho
          .cf-side__media
            img.cf-side__img(v-if="takeRedRobot.image" :src="takeRedRobot.image" alt="")
            FontAwesomeIcon.cf-side__ph(v-else :icon="['fas','robot']")
          span.cf-side__name {{ takeRedRobot.name || 'A definir' }}
          .cf-side__judge(v-if="canCount && step === 1")
            span.cf-side__aggr
              span.cf-side__aggr-k Agressividade
              span.cf-side__aggr-v {{ aggressivityRed }}
            Select.cf-side__select(
              defaultText="Selecionar Dano"
              :options="takeDamageOptions"
              type='drop'
              @emit="doSetRedDamage"
            )

      //- ----- Cronômetro do round (juiz de round) -----
      section.cf-crono(
        v-if="isRoundJudge"
        :class="{ 'cf-crono--on': cronoRodando, 'cf-crono--fim': cronoAcabou }"
      )
        .cf-crono__display
          span.cf-crono__tempo {{ cronoTexto }}
          span.cf-crono__estado {{ cronoEstadoTexto }}
        .cf-crono__acoes
          button.btn.btn--solid(@click="doCronoAlternar")
            FontAwesomeIcon.btn__ic(:icon="['fas', cronoRodando ? 'pause' : 'play']")
            span {{ cronoBotaoTexto }}
          button.cf-crono__sec(@click="doCronoZerar")
            FontAwesomeIcon.cf-crono__sec-ic(:icon="['fas','undo']")
            span Zerar
          //- link comum (não window.open): bloqueador de pop-up engole o open()
          a.cf-crono__sec(:href="cronoUrl" target="_blank" rel="noopener")
            FontAwesomeIcon.cf-crono__sec-ic(:icon="['fas','external-link-alt']")
            span Abrir em outra aba
        p.cf-crono__dica Round de 2 minutos. A barra de espaço pausa e volta do mesmo ponto, e a aba grande fica em sincronia com esta tela.

      //- ----- Cola do critério de dano (etapa do dano) -----
      section.cf-cola(v-if="canCount && step === 1")
        .cf-cola__strip
          span.cf-cola__pill(v-for="n in niveisDano" :key="'p' + n.nivel")
            strong {{ n.nivel }}
            | {{ n.nome }}
        button.cf-cola__toggle(@click="showCola = !showCola")
          FontAwesomeIcon.cf-cola__toggle-ic(:icon="['fas','book']")
          span {{ showCola ? 'Fechar o critério de dano' : 'Ver o critério de dano (LBR)' }}
          FontAwesomeIcon.cf-cola__chev(:icon="['fas', showCola ? 'chevron-up' : 'chevron-down']")

        .cf-cola__body(v-if="showCola")
          .cf-cola__nivel(v-for="n in niveisDano" :key="'n' + n.nivel")
            span.cf-cola__nivel-tag {{ n.nivel }} · {{ n.nome }}
            p.cf-cola__nivel-def {{ n.definicao }}
            ul.cf-cola__ex
              li(v-for="(e, i) in n.exemplos" :key="i") {{ e }}

          h3.cf-cola__sub Distribuição dos 18 pontos de dano
          p.cf-cola__nota
            | Linha = nível sofrido pelo <strong>azul</strong>, coluna = nível sofrido pelo <strong>vermelho</strong>. O par é azul&nbsp;-&nbsp;vermelho.
          .cf-cola__tabwrap
            table.cf-cola__tab
              thead
                tr
                  th.cf-cola__corner AZ \ VM
                  th(v-for="n in niveisDano" :key="'h' + n.nivel") {{ n.nivel }}
              tbody
                tr(v-for="(linha, li) in tabelaDano" :key="'l' + li")
                  th {{ li }}
                  td(
                    v-for="(cel, ci) in linha"
                    :key="'c' + ci"
                    :class="{ 'cf-cola__tab-eq': li === ci }"
                  ) {{ cel }}
          p.cf-cola__nota
            | Nesta tela você lança o <strong>nível de dano sofrido</strong> por cada robô (0&nbsp;Trivial … 5&nbsp;Massivo) — <strong>não</strong> os pontos. Os 18 pontos da luta saem sozinhos da tabela acima, usando o maior nível registrado entre os 3 jurados.
          p.cf-cola__nota
            | <strong>Empate em Maior (4):</strong> se um dos robôs também sofreu dano Significativo (3) na locomoção, o outro passa a valer como Significativo (3) só para pontuar. O registro real do dano não muda.

      //- ----- Aviso ao juiz de round (etapa 0) -----
      .cf-info(v-if="isRoundJudge && step === 0")
        FontAwesomeIcon.cf-info__ic(:icon="['fas', 'user-shield']")
        .cf-info__txt(v-if="isDualJudge")
          strong Você acumula juiz de round e juiz de combate
          span Conte os acertos abaixo e avance. Depois de lançar o dano, você confere o placar dos juízes e encerra a luta.
        .cf-info__txt(v-else)
          strong Você é o juiz de round desta luta
          span Os juízes de combate contam os acertos nos dispositivos deles. Quando os 3 lançarem a contagem, clique em Próximo para conferir o placar e finalizar.

      //- ----- Ação principal + avisos -----
      .cf-stage(v-if="isCombatJudge || isRoundJudge")
        button.btn.btn--solid.btn--big(@click="doSetAction")
          FontAwesomeIcon.btn__ic(:icon="actionIcon")
          span {{ takeButtonText }}
        p.cf-stage__error(v-if="showErrorCount && step === 0")
          FontAwesomeIcon.cf-stage__error-ic(:icon="['fas','exclamation-triangle']")
          | Empate na contagem: adicione um ponto a um dos robôs para desempatar.
        p.cf-stage__error(v-if="showErrorJudges")
          FontAwesomeIcon.cf-stage__error-ic(:icon="['fas','exclamation-triangle']")
          | Nem todos os juízes finalizaram a contagem.
        p.cf-stage__error(v-if="showErrorDamage")
          FontAwesomeIcon.cf-stage__error-ic(:icon="['fas','exclamation-triangle']")
          | Selecione o nível de dano dos dois robôs antes de lançar.

      //- ----- Encerrar por Nocaute / WO (juiz de round, sem placar dos 3 juízes) -----
      .cf-kowo(v-if="isRoundJudge")
        button.cf-kowo__toggle(@click="showKoWo = !showKoWo")
          FontAwesomeIcon.cf-kowo__toggle-ic(:icon="['fas','flag-checkered']")
          span {{ showKoWo ? 'Cancelar encerramento direto' : 'Encerrar por Nocaute ou WO' }}
        .cf-kowo__body(v-if="showKoWo")
          p.cf-kowo__hint Encerra a luta sem o placar dos 3 juízes. Escolha o tipo e o vencedor.
          .cf-kowo__row
            span.cf-kowo__row-label Nocaute / Desist.
            button.btn.btn--blue-solid(@click="doDeclareResult(3, takeBlueRobot.id)")
              FontAwesomeIcon.btn__ic(:icon="['fas','trophy']")
              span {{ takeBlueRobot.name }}
            button.btn.btn--red-solid(@click="doDeclareResult(3, takeRedRobot.id)")
              FontAwesomeIcon.btn__ic(:icon="['fas','trophy']")
              span {{ takeRedRobot.name }}
          .cf-kowo__row
            span.cf-kowo__row-label WO
            button.btn.btn--blue-solid(@click="doDeclareResult(1, takeBlueRobot.id)")
              FontAwesomeIcon.btn__ic(:icon="['fas','flag']")
              span {{ takeBlueRobot.name }}
            button.btn.btn--red-solid(@click="doDeclareResult(1, takeRedRobot.id)")
              FontAwesomeIcon.btn__ic(:icon="['fas','flag']")
              span {{ takeRedRobot.name }}

      //- ----- Contadores de agressividade (juiz de combate, etapa 0) -----
      .cf-counters(v-if="canCount && step === 0")
        button.cf-counter.cf-counter--blue(@click="doUpBlue")
          span.cf-counter__label Acertos · Azul
          span.cf-counter__value {{ aggressivityBlue }}
          span.cf-counter__hint
            FontAwesomeIcon(:icon="['fas','hand-pointer']")
            | Toque para contar
        button.cf-counter.cf-counter--red(@click="doUpRed")
          span.cf-counter__label Acertos · Vermelho
          span.cf-counter__value {{ aggressivityRed }}
          span.cf-counter__hint
            FontAwesomeIcon(:icon="['fas','hand-pointer']")
            | Toque para contar

      //- ----- Pontuação dos juízes (juiz de round, etapa final) -----
      .cf-scores(v-if="showScores")
        h2.cf-scores__title Pontuação dos juízes
        .cf-scores__grid(v-if="takeDamages.length")
          .cf-judge(v-for="(judge, i) in takeDamages" :key="i")
            span.cf-judge__name
              FontAwesomeIcon.cf-judge__name-ic(:icon="['fas','user-shield']")
              | Juiz {{ judge.judge_name }}
            .cf-judge__grid
              .cf-judge__cell.cf-judge__cell--blue
                span.cf-judge__k Dano azul (nível)
                span.cf-judge__v {{ doNomeNivelDano(judge.blue_damage_scores) }}
              .cf-judge__cell.cf-judge__cell--blue
                span.cf-judge__k Agr. azul
                span.cf-judge__v {{ judge.blue_aggressivity_scores }}
              .cf-judge__cell.cf-judge__cell--red
                span.cf-judge__k Dano verm. (nível)
                span.cf-judge__v {{ doNomeNivelDano(judge.red_damage_scores) }}
              .cf-judge__cell.cf-judge__cell--red
                span.cf-judge__k Agr. verm.
                span.cf-judge__v {{ judge.red_aggressivity_scores }}

        .cf-totals(v-if="takeFinalScore")
          .cf-total.cf-total--blue(:class="takeWinnerModifier.blue")
            FontAwesomeIcon.cf-total__crown(v-if="takeWinnerModifier.blue.length" :icon="['fas','crown']")
            span.cf-total__label Total Azul · {{ takeBlueRobot.name }}
            span.cf-total__value {{ takeFinalScore.blue_sum }}
          .cf-total.cf-total--red(:class="takeWinnerModifier.red")
            FontAwesomeIcon.cf-total__crown(v-if="takeWinnerModifier.red.length" :icon="['fas','crown']")
            span.cf-total__label Total Vermelho · {{ takeRedRobot.name }}
            span.cf-total__value {{ takeFinalScore.red_sum }}

      //- ----- Desempate (juiz de round) -----
      .cf-tie(v-if="showTieBreaker")
        p.cf-tie__title
          FontAwesomeIcon.cf-tie__title-ic(:icon="['fas','exclamation-triangle']")
          | Empate detectado. Selecione o robô vencedor:
        .cf-tie__robots
          button.btn.btn--blue-solid(@click="doResolveTie(takeBlueRobot.id)")
            FontAwesomeIcon.btn__ic(:icon="['fas','trophy']")
            span {{ takeBlueRobot.name }}
          button.btn.btn--red-solid(@click="doResolveTie(takeRedRobot.id)")
            FontAwesomeIcon.btn__ic(:icon="['fas','trophy']")
            span {{ takeRedRobot.name }}
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'

import {
  Select
} from '@/components/atoms'

import {
  DURACAO_MS,
  ler as lerCrono,
  observar as observarCrono,
  restanteDe,
  alternar as alternarCrono,
  zerar as zerarCrono,
  formatar as formatarCrono
} from '@/utils/cronometro'

// Cola do "Critério para julgamento dos rounds de combate" da LBR (rev. 09/08/2026),
// seções 2.1.2 (níveis), 2.1.4 (diferenciação) e 2.1.5 (distribuição) + Apêndice A.
// Fica na tela para o jurado consultar durante o round, sem trocar de aplicativo.
const NIVEIS_DANO = [
  {
    nivel: 0,
    nome: 'Trivial',
    definicao: 'Nenhum dano contabilizável. O oponente não conseguiu nenhum hit, ou o robô saiu como entrou numa luta contra arma passiva.',
    exemplos: ['Perda de adesivos decorativos', 'Riscos superficiais na armadura ou na arma', 'Perda de afiação da arma ou dos forks']
  },
  {
    nivel: 1,
    nome: 'Cosmético',
    definicao: 'Danos pequenos, sem remoção nem empenamento de peças, que não mudam o pleno funcionamento do robô.',
    exemplos: ['Perda de fita adesiva pouco estrutural', 'Perda de parafusos, arruelas ou porcas', 'Rasgos pequenos em rodas ou leves deformações', 'Marcas de queima ou fuligem sem comprometer a estrutura']
  },
  {
    nivel: 2,
    nome: 'Menor',
    definicao: 'Danos estruturalmente relevantes, incluindo remoção ou empenamento de peças, que ainda assim não afetam as funcionalidades principais.',
    exemplos: ['Amassamentos, cortes ou empenamentos sem perda de função', 'Empenamento ou remoção de forks de robô de arma ativa', 'Remoção de roda sem afetar a mobilidade', 'Fumaça intermitente sem queda de potência']
  },
  {
    nivel: 3,
    nome: 'Significativo',
    definicao: 'Danos que reduzem parcialmente as funcionalidades do robô.',
    exemplos: ['Fumaça contínua ou perda parcial de potência', 'Perda parcial de mobilidade', 'Arma girando mais devagar ou com vibração severa', 'Empenamento de eixos, rampas ou forks de arma passiva']
  },
  {
    nivel: 4,
    nome: 'Maior',
    definicao: 'Danos completamente críticos para as funcionalidades do robô.',
    exemplos: ['Perda total da arma ativa', 'Perda da mobilidade controlada', 'Remoção completa de rampas ou forks de arma passiva', 'Componentes internos arrancados ou arrastando na arena']
  },
  {
    nivel: 5,
    nome: 'Massivo',
    definicao: 'O robô perde totalmente locomoção e arma, ficando inoperante.',
    exemplos: ['Robô parado, sem responder e sem arma']
  }
]

// Tabela 2.1.5: linha = nível sofrido pelo azul, coluna = nível sofrido pelo
// vermelho; a célula é "pontos do azul - pontos do vermelho", somando 18.
const TABELA_DANO = [
  ['9 - 9', '10 - 8', '12 - 6', '14 - 4', '16 - 2', '18 - 0'],
  ['8 - 10', '9 - 9', '10 - 8', '12 - 6', '14 - 4', '17 - 1'],
  ['6 - 12', '8 - 10', '9 - 9', '11 - 7', '13 - 5', '15 - 3'],
  ['4 - 14', '6 - 12', '7 - 11', '9 - 9', '11 - 7', '13 - 5'],
  ['2 - 16', '4 - 14', '5 - 13', '7 - 11', '9 - 9', '11 - 7'],
  ['0 - 18', '1 - 17', '3 - 15', '5 - 13', '7 - 11', '9 - 9']
]

export default {
  name: 'CurrentFight',
  data: () => ({
    showCola: false,
    aggressivityBlue: 0,
    aggressivityRed: 0,
    damageBlue: null,
    damageRed: null,
    showErrorDamage: false,
    step: 0,
    showErrorCount: false,
    showErrorJudges: false,
    showTieBreaker: false,
    tieResolved: false,
    showKoWo: false,
    cronoEstado: null,
    cronoRestante: DURACAO_MS,
    cronoTick: null,
    cronoParar: null
  }),
  components: {
    Select
  },
  mounted () {},
  created () {
    // Cronômetro: o estado vive fora do componente (localStorage + canal entre
    // abas), então recarregar a tela no meio do round não perde o tempo.
    this.cronoEstado = lerCrono()
    this.doCronoRecalcular()
    this.cronoTick = setInterval(this.doCronoRecalcular, 200)
    this.cronoParar = observarCrono((novo) => {
      this.cronoEstado = novo
      this.doCronoRecalcular()
    })
    window.addEventListener('keydown', this.doCronoTecla)
  },
  beforeDestroy () {
    clearInterval(this.cronoTick)
    if (this.cronoParar) this.cronoParar()
    window.removeEventListener('keydown', this.doCronoTecla)
    this.setCleanCurrentFight()
  },
  computed: {
    ...mapGetters('users', [
      'getUser'
    ]),
    ...mapGetters('fights', [
      'getCurrentFight'
    ]),
    // currentFight é populado ao entrar numa luta (array de robôs + metadados).
    // Vazio/objeto ({}) significa que não há luta carregada — evita renderizar
    // matchup/contadores e o crash de .find no doSetAction.
    hasFight () {
      return Array.isArray(this.getCurrentFight) && this.getCurrentFight.length > 0
    },
    takeJudgeId () {
      if (this.getCurrentFight.length) {
        const meta = this.getCurrentFight.find(obj => obj.round_judge_id != null)
        return meta ? meta.round_judge_id : -1
      }
      return -1
    },
    userRoles () {
      return (this.getUser && this.getUser.roles) || []
    },
    // juiz de combate: conta agressividade e lança dano. Vale TAMBÉM para quem
    // acumula juiz de round (admin/juiz com os dois papéis julga a própria luta).
    // Admin (1) acumula todas as funções.
    isCombatJudge () {
      return this.userRoles.includes(3) || this.userRoles.includes(1)
    },
    canCount () {
      return this.isCombatJudge
    },
    // juiz de round DESTA luta (foi quem a inicializou; papel 4 já exigido lá)
    isRoundJudge () {
      return this.hasFight && this.getUser.id === this.takeJudgeId
    },
    // acumula os dois papéis: conta/lança dano e depois confere o placar e encerra
    isDualJudge () {
      return this.isRoundJudge && this.isCombatJudge
    },
    // painel de placar do juiz de round: etapa 1 (puro) ou 2 (acumulado)
    showScores () {
      return this.isRoundJudge && this.step === (this.isCombatJudge ? 2 : 1)
    },
    stageTotal () {
      return this.isDualJudge ? 3 : 2
    },
    stageLabel () {
      if (this.isDualJudge) {
        return ['Contagem', 'Dano', 'Resultado'][this.step] || 'Resultado'
      }
      return this.step === 0 ? 'Contagem' : 'Dano e resultado'
    },
    actionIcon () {
      const t = (this.takeButtonText || '').toLowerCase()
      return t.includes('finalizar') ? ['fas', 'flag-checkered'] : ['fas', 'arrow-right']
    },
    takeBlueRobot () {
      if (this.getCurrentFight.length) {
        return this.getCurrentFight.find(robot => robot.id && robot.name && !robot.is_red_side)
      }
      return { name: '' }
    },
    takeRedRobot () {
      if (this.getCurrentFight.length) {
        return this.getCurrentFight.find(robot => robot.id && robot.name && robot.is_red_side)
      }
      return { name: '' }
    },
    takeCategory () {
      if (this.getCurrentFight.length) {
        return this.getCurrentFight.find(obj => obj.category_name).category_name
      }
      return ''
    },
    takeButtonText () {
      if (this.step === 0) {
        return 'Próximo'
      }
      if (this.isDualJudge) {
        return this.step === 1 ? 'Lançar dano' : 'Finalizar julgamento'
      }
      if (this.isRoundJudge) {
        return 'Finalizar julgamento'
      }
      return 'Finalizar' // juiz de combate puro: lança o dano e sai
    },
    takeDamageOptions () {
      // Níveis oficiais de dano (regras 2.1.2): o jurado classifica o NÍVEL
      // sofrido pelo robô; os pontos saem da tabela 2.1.5 no backend.
      return NIVEIS_DANO.map(n => ({ text: `${n.nivel} — ${n.nome}`, value: n.nivel }))
    },
    cronoRodando () {
      return !!(this.cronoEstado && this.cronoEstado.rodando) && this.cronoRestante > 0
    },
    cronoAcabou () {
      return this.cronoRestante <= 0
    },
    cronoTexto () {
      return formatarCrono(this.cronoRestante)
    },
    cronoEstadoTexto () {
      if (this.cronoAcabou) return 'Tempo esgotado'
      return this.cronoRodando ? 'Em andamento' : 'Pausado'
    },
    cronoBotaoTexto () {
      if (this.cronoRodando) return 'Pausar'
      if (this.cronoRestante >= DURACAO_MS) return 'Iniciar round'
      return 'Continuar'
    },
    cronoFightId () {
      if (!this.hasFight) return 0
      const meta = this.getCurrentFight.find(obj => obj.id)
      return meta ? meta.id : 0
    },
    cronoUrl () {
      return '/Cronometro?' + [
        'luta=' + this.cronoFightId,
        'azul=' + encodeURIComponent(this.takeBlueRobot.name || ''),
        'vermelho=' + encodeURIComponent(this.takeRedRobot.name || '')
      ].join('&')
    },
    niveisDano () {
      return NIVEIS_DANO
    },
    tabelaDano () {
      return TABELA_DANO
    },
    takeScoresObj () {
      if (this.getCurrentFight.length >= 4) {
        return this.getCurrentFight.find(obj => obj.firstJudge) || null
      }
      return null
    },
    takeDamages () {
      if (!this.takeScoresObj) return []
      return ['firstJudge', 'secondJudge', 'thirdJudge']
        .map(k => this.takeScoresObj[k])
        .filter(j => j != null)
    },
    takeFinalScore () {
      return this.takeScoresObj ? this.takeScoresObj.scores : {}
    },
    isTie () {
      const s = this.takeFinalScore
      return s && s.blue_sum != null && s.red_sum != null && s.blue_sum === s.red_sum
    },
    takeWinnerModifier () {
      if (this.takeFinalScore.blue_sum > this.takeFinalScore.red_sum) {
        return { red: [], blue: ['value--winner'] }
      }
      return { red: ['value--winner'], blue: [] }
    }
  },
  methods: {
    ...mapActions('fights',
      [
        'setCleanCurrentFight',
        'setfightAggressivity',
        'setFightDamage',
        'setFinishFight',
        'setInfoJudgeScoreFight',
        'setJudgeDecision'
      ]),
    doUpRed () {
      this.aggressivityRed = this.aggressivityRed + 1
    },
    doNomeNivelDano (nivel) {
      // Mostra o nível de dano com o nome oficial (ex.: "4 — Maior").
      if (nivel == null) return '—'
      const n = NIVEIS_DANO.find(x => x.nivel === nivel)
      return n ? `${n.nivel} — ${n.nome}` : String(nivel)
    },
    doSetRedDamage (e) {
      this.damageRed = e
    },
    doUpBlue () {
      this.aggressivityBlue = this.aggressivityBlue + 1
    },
    doSetBlueDamage (e) {
      this.damageBlue = e
    },
    doResolveTie (robotId) {
      if (!this.hasFight) return
      const id = this.getCurrentFight.find(obj => obj.id).id
      this.setJudgeDecision({
        judge_id: this.getUser.id,
        fight_id: id,
        winner_id: robotId,
        blue_id: this.takeBlueRobot.id
      }).then(() => {
        this.showTieBreaker = false
        this.tieResolved = true
        // juiz de round puro: avança pro placar; acumulado já está na etapa final
        if (!this.isDualJudge) {
          this.step = this.step + 1
        }
      })
    },
    // Busca o placar dos juízes e valida: precisa de contagem lançada e sem
    // empate pendente. Devolve Promise<boolean> (ok pra avançar/encerrar).
    doCheckJudgesScores (id) {
      return this.setInfoJudgeScoreFight({ fight_id: id }).then(() => {
        const scoresObj = this.getCurrentFight.find(obj => obj.firstJudge)
        const judges = scoresObj
          ? ['firstJudge', 'secondJudge', 'thirdJudge'].filter(k => scoresObj[k] != null)
          : []
        if (!judges.length) {
          this.showErrorJudges = true
          return false
        }
        this.showErrorJudges = false
        if (this.isTie && !this.tieResolved) {
          this.showTieBreaker = true
          return false
        }
        return true
      })
    },
    doFinish (id) {
      this.setFinishFight({ fight_id: id }).then(res =>
        this.$router.push('Fights')
      )
    },
    // Encerramento direto por Nocaute (victory_type=3) ou WO (1): o juiz de round
    // declara o vencedor sem o placar dos 3 juízes. O backend grava o tipo (= pontos
    // na fase de grupos) e define o vencedor a partir do winner_id.
    doDeclareResult (victoryType, winnerId) {
      if (!this.hasFight || !winnerId) return
      const id = this.getCurrentFight.find(obj => obj.id).id
      this.setFinishFight({ fight_id: id, victory_type: victoryType, winner_id: winnerId })
        .then(() => this.$router.push('Fights'))
    },
    // —— cronômetro do round ——
    doCronoRecalcular () {
      this.cronoRestante = restanteDe(this.cronoEstado)
    },
    doCronoAlternar () {
      this.cronoEstado = alternarCrono(this.cronoEstado, this.cronoFightId)
      this.doCronoRecalcular()
    },
    doCronoZerar () {
      this.cronoEstado = zerarCrono(this.cronoFightId)
      this.doCronoRecalcular()
    },
    doCronoTecla (e) {
      if (!this.isRoundJudge) return
      if (e.code !== 'Space' && e.key !== ' ') return
      // não sequestra a barra quando o foco está num campo ou botão (lá o espaço
      // já tem função própria: digitar, abrir o select, acionar o botão)
      const alvo = (e.target && e.target.tagName) || ''
      if (['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON'].includes(alvo) || (e.target && e.target.isContentEditable)) return
      e.preventDefault()
      this.doCronoAlternar()
    },
    doSetAction () {
      if (!this.hasFight) return
      const fight = this.getCurrentFight
      const id = fight.find(obj => obj.id).id

      if (this.step === 0) {
        if (this.isCombatJudge) {
          // juiz de combate (inclusive acumulando juiz de round): lança a contagem
          if (this.aggressivityRed === this.aggressivityBlue) {
            this.showErrorCount = true
            return
          }
          this.setfightAggressivity({
            judge_id: this.getUser.id,
            fight_id: id,
            red_id: fight.find(f => f.name && f.is_red_side).id,
            blue_id: fight.find(f => f.name && !f.is_red_side).id,
            red_hits: this.aggressivityRed,
            blue_hits: this.aggressivityBlue
          })
          this.step = 1
        } else if (this.isRoundJudge) {
          // juiz de round puro: confere se os juízes lançaram a contagem
          this.doCheckJudgesScores(id).then(ok => {
            if (ok) this.step = 1
          })
        }
        return
      }

      if (this.step === 1) {
        if (this.isCombatJudge) {
          // Nível de dano é obrigatório pros dois robôs — sem seleção, um envio
          // viraria nível 0 (Trivial) silenciosamente e distorceria a tabela.
          if (this.damageRed == null || this.damageBlue == null) {
            this.showErrorDamage = true
            return
          }
          this.showErrorDamage = false
          // lança o dano
          this.setFightDamage({
            judge_id: this.getUser.id,
            fight_id: id,
            red_id: fight.find(f => f.name && f.is_red_side).id,
            blue_id: fight.find(f => f.name && !f.is_red_side).id,
            red_damage: this.damageRed.value,
            blue_damage: this.damageBlue.value
          }).then(() => {
            if (this.isRoundJudge) {
              // acumulado: segue pro fechamento (já pré-carrega o placar)
              this.step = 2
              this.doCheckJudgesScores(id)
            } else {
              this.$router.push('Fights')
            }
          })
        } else if (this.isRoundJudge) {
          // juiz de round puro: placar já validado na etapa anterior
          this.doFinish(id)
        }
        return
      }

      // etapa 2 (só juiz acumulado): revalida o placar e encerra a luta
      this.doCheckJudgesScores(id).then(ok => {
        if (ok) this.doFinish(id)
      })
    }
  }
}
</script>

<style lang="sass" scoped>
  $blue: #287AED
  $blue-dark: #0F4FA8
  $red: #DD3434
  $red-dark: #B0231F
  $green: #2E9E4F
  $green-dark: #1F7C3C
  $gold: #F9A825
  $ink: #0B0E14
  $muted: #5C6673
  $line: rgba(11, 14, 20, 0.10)
  $paper: #FFFFFF
  $mist: #EEF1F6
  $page: #F2F4F8
  $display: 'Saira Condensed', 'Lato', sans-serif
  $mono: 'Space Mono', 'Lato', monospace

  .current-fight
    color: $ink
    background: $page
    min-height: calc(100vh - 64px)
    font-family: Lato, sans-serif

    *
      box-sizing: border-box

    // ---------- HERO ----------
    &__hero
      position: relative
      overflow: hidden
      isolation: isolate
      padding: 30px 0 40px
      background: radial-gradient(circle at 16% 8%, #15233b 0%, $ink 52%, #05070b 100%)
      color: #fff

    &__hero-grid
      position: absolute
      inset: 0
      background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
      background-size: 42px 42px
      mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
      -webkit-mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
      z-index: -2

    &__hero-glow
      position: absolute
      width: 360px
      height: 360px
      border-radius: 50%
      filter: blur(110px)
      opacity: 0.5
      z-index: -1
      &--blue
        background: $blue
        top: -170px
        left: -90px
      &--red
        background: $red
        bottom: -190px
        right: -70px

    &__hero-inner
      position: relative
      max-width: 1040px
      margin: 0 auto
      padding: 0 24px
      > *
        animation: cf-rise .55s cubic-bezier(.2, .7, .2, 1) both
      .current-fight__title
        animation-delay: .06s
      .current-fight__hero-meta
        animation-delay: .12s

    &__eyebrow
      display: inline-flex
      align-items: center
      gap: 10px
      font-family: $mono
      text-transform: uppercase
      letter-spacing: 0.22em
      font-size: 12px
      font-weight: 700
      color: rgba(255, 255, 255, 0.7)
      margin: 0 0 12px

    &__eyebrow-pip
      width: 8px
      height: 8px
      border-radius: 50%
      background: linear-gradient(135deg, #5AA0FF, $red)
      box-shadow: 0 0 0 4px rgba(90, 160, 255, 0.15)

    &__title
      font-family: $display
      font-weight: 800
      text-transform: uppercase
      font-size: clamp(38px, 6vw, 56px)
      line-height: 0.96
      letter-spacing: -0.01em
      margin: 0

    &__hero-meta
      display: flex
      flex-wrap: wrap
      align-items: center
      gap: 10px
      margin-top: 16px

    &__live
      display: inline-flex
      align-items: center
      gap: 8px
      font-family: $mono
      font-size: 11px
      font-weight: 700
      text-transform: uppercase
      letter-spacing: 0.1em
      color: #fff
      padding: 7px 14px
      border-radius: 999px
      background: rgba(221, 52, 52, 0.18)
      border: 1px solid rgba(221, 52, 52, 0.5)

    &__live-dot
      width: 8px
      height: 8px
      border-radius: 50%
      background: #FF6B6B
      box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.6)
      animation: cf-pulse 1.5s ease-out infinite

    &__chip
      display: inline-flex
      align-items: center
      gap: 8px
      font-family: $mono
      font-size: 11px
      font-weight: 700
      text-transform: uppercase
      letter-spacing: 0.06em
      color: rgba(255, 255, 255, 0.85)
      padding: 7px 14px
      border-radius: 999px
      background: rgba(255, 255, 255, 0.07)
      border: 1px solid rgba(255, 255, 255, 0.14)

    &__chip-ic
      font-size: 12px
      color: #6FB0FF

    // ---------- CORPO ----------
    &__wrap
      max-width: 1040px
      margin: 0 auto
      padding: 32px 24px 72px
      display: flex
      flex-direction: column
      gap: 24px

    // ---------- ESTADO SEM LUTA ----------
    .cf-empty
      display: flex
      flex-direction: column
      align-items: center
      justify-content: center
      text-align: center
      gap: 8px
      padding: 72px 24px
      background: $paper
      border: 1px dashed rgba(11, 14, 20, 0.16)
      border-radius: 18px
      box-shadow: 0 12px 30px rgba(11, 14, 20, 0.06)
      &__ic
        font-size: 48px
        margin-bottom: 6px
      &__title
        font-family: $display
        text-transform: uppercase
        font-weight: 700
        font-size: 24px
        margin: 0
      &__text
        color: $muted
        font-size: 15px
        margin: 0 0 14px
        max-width: 380px

    // ---------- CONFRONTO ----------
    .cf-matchup
      display: grid
      grid-template-columns: 1fr auto 1fr
      align-items: stretch
      gap: 16px
      background: $paper
      border: 1px solid $line
      border-radius: 18px
      padding: 24px
      box-shadow: 0 12px 30px rgba(11, 14, 20, 0.06)
      @media (max-width: 640px)
        grid-template-columns: 1fr
        gap: 12px

      &__vs
        display: flex
        align-items: center
        justify-content: center
        span
          display: grid
          place-items: center
          width: 54px
          height: 54px
          border-radius: 50%
          font-family: $display
          font-weight: 800
          font-size: 18px
          color: #fff
          background: $ink
          box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.9), 0 8px 20px rgba(11, 14, 20, 0.32)

    .cf-side
      display: flex
      flex-direction: column
      align-items: center
      gap: 12px
      padding: 20px 16px
      border-radius: 14px
      &--blue
        background: radial-gradient(circle at 50% 0%, rgba(40, 122, 237, 0.12), rgba(40, 122, 237, 0.03) 78%)
        box-shadow: inset 0 0 0 1px rgba(40, 122, 237, 0.22)
        .cf-side__tag-ic, .cf-side__ph
          color: $blue
      &--red
        background: radial-gradient(circle at 50% 0%, rgba(221, 52, 52, 0.12), rgba(221, 52, 52, 0.03) 78%)
        box-shadow: inset 0 0 0 1px rgba(221, 52, 52, 0.22)
        .cf-side__tag-ic, .cf-side__ph
          color: $red

      &__tag
        display: inline-flex
        align-items: center
        gap: 8px
        font-family: $mono
        text-transform: uppercase
        letter-spacing: 0.1em
        font-size: 10px
        font-weight: 700
        color: $muted

      &__tag-ic
        font-size: 13px

      &__media
        display: flex
        align-items: center
        justify-content: center
        height: 150px
        width: 100%
        padding: 8px

      &__img
        max-width: 100%
        max-height: 100%
        object-fit: contain
        filter: drop-shadow(0 8px 16px rgba(11, 14, 20, 0.2))

      &__ph
        font-size: 72px
        opacity: 0.5

      &__name
        font-family: $display
        text-transform: uppercase
        font-weight: 800
        font-size: 24px
        line-height: 1.05
        text-align: center
        color: $ink
        overflow-wrap: anywhere

      &__judge
        width: 100%
        display: flex
        flex-direction: column
        gap: 10px
        margin-top: 4px
        padding-top: 14px
        border-top: 1px dashed $line

      &__aggr
        display: flex
        align-items: center
        justify-content: space-between
        gap: 10px
        padding: 8px 14px
        border-radius: 10px
        background: $mist
        &-k
          font-family: $mono
          font-size: 11px
          font-weight: 700
          text-transform: uppercase
          letter-spacing: 0.06em
          color: $muted
        &-v
          font-family: $display
          font-size: 22px
          font-weight: 800
          color: $ink

    // Select (atom) de dano harmonizado
    .cf-side__select
      width: 100%
      ::v-deep .select__default
        .text
          border-color: $line
          border-radius: 10px 0 0 10px
          height: 46px
          font-family: $display
          font-weight: 600
        .icon
          border-color: $line
          border-radius: 0 10px 10px 0
          height: 46px
          background: $paper
      ::v-deep .select__options .option
        border-color: $line
        border-radius: 10px

    // ---------- CRONÔMETRO DO ROUND ----------
    .cf-crono
      display: flex
      flex-wrap: wrap
      align-items: center
      gap: 16px
      padding: 16px 20px
      border-radius: 14px
      background: radial-gradient(circle at 12% 20%, #15233b 0%, $ink 70%)
      color: #fff

      &__display
        display: flex
        flex-direction: column
        min-width: 150px

      &__tempo
        font-family: $mono
        font-size: 44px
        font-weight: 700
        line-height: 1
        font-variant-numeric: tabular-nums

      &__estado
        margin-top: 4px
        font-size: 12px
        letter-spacing: 0.18em
        text-transform: uppercase
        color: $gold

      &__acoes
        display: flex
        flex-wrap: wrap
        gap: 10px
        margin-left: auto

      &__sec
        display: inline-flex
        align-items: center
        gap: 8px
        padding: 12px 16px
        border: 1px solid rgba(255, 255, 255, 0.28)
        border-radius: 999px
        background: transparent
        color: rgba(255, 255, 255, 0.88)
        font-family: $display
        font-size: 14px
        font-weight: 700
        letter-spacing: 0.06em
        text-transform: uppercase
        text-decoration: none // o "abrir em outra aba" é um <a>
        cursor: pointer

      &__sec-ic
        font-size: 13px

      &__dica
        flex-basis: 100%
        margin: 0
        font-size: 12px
        line-height: 1.5
        color: rgba(255, 255, 255, 0.55)

      &--on &__estado
        color: $green

      &--fim
        background: radial-gradient(circle at 12% 20%, #4a0d0d 0%, #1a0505 70%)
      &--fim &__estado
        color: $red
      &--fim &__tempo
        color: $red

    // ---------- COLA DO CRITÉRIO DE DANO ----------
    .cf-cola
      background: $paper
      border: 1px solid $line
      border-radius: 14px
      padding: 14px 16px

      &__strip
        display: flex
        flex-wrap: wrap
        gap: 8px

      &__pill
        display: inline-flex
        align-items: baseline
        gap: 6px
        padding: 6px 10px
        border-radius: 999px
        background: $mist
        border: 1px solid $line
        font-size: 12px
        letter-spacing: 0.03em
        text-transform: uppercase
        color: $muted
        strong
          font-family: $mono
          font-size: 13px
          color: $ink

      &__toggle
        display: flex
        align-items: center
        gap: 10px
        width: 100%
        margin-top: 12px
        padding: 10px 12px
        border: 1px dashed rgba(40, 122, 237, 0.45)
        border-radius: 10px
        background: rgba(40, 122, 237, 0.05)
        color: $blue-dark
        font-family: $display
        font-size: 14px
        font-weight: 700
        letter-spacing: 0.04em
        text-transform: uppercase
        cursor: pointer
        span
          flex: 1
          text-align: left

      &__chev
        font-size: 12px

      &__body
        margin-top: 14px
        display: flex
        flex-direction: column
        gap: 14px

      &__nivel
        border-left: 3px solid $blue
        padding-left: 12px

      &__nivel-tag
        display: inline-block
        font-family: $display
        font-size: 15px
        font-weight: 700
        letter-spacing: 0.04em
        text-transform: uppercase
        color: $ink

      &__nivel-def
        margin: 4px 0 6px
        font-size: 14px
        line-height: 1.5
        color: $muted

      &__ex
        margin: 0
        padding-left: 18px
        li
          font-size: 13px
          line-height: 1.6
          color: $muted

      &__sub
        margin: 4px 0 0
        font-family: $display
        font-size: 17px
        font-weight: 700
        letter-spacing: 0.04em
        text-transform: uppercase
        color: $ink

      &__nota
        margin: 0
        font-size: 13px
        line-height: 1.6
        color: $muted
        strong
          color: $ink

      // a tabela é larga para celular: rola sozinha, sem espremer a fonte
      &__tabwrap
        overflow-x: auto
        -webkit-overflow-scrolling: touch

      &__tab
        border-collapse: collapse
        width: 100%
        min-width: 420px
        font-family: $mono
        font-size: 12px
        th, td
          border: 1px solid $line
          padding: 6px 8px
          text-align: center
          white-space: nowrap
        thead th
          background: $mist
          color: $ink
        tbody th
          background: $mist
          color: $ink
        td
          color: $muted

      &__corner
        font-family: $display
        letter-spacing: 0.04em

      &__tab-eq
        background: rgba(11, 14, 20, 0.04)
        color: $ink

    // ---------- AVISO AO JUIZ DE ROUND ----------
    .cf-info
      display: flex
      align-items: flex-start
      gap: 14px
      padding: 16px 20px
      background: rgba(40, 122, 237, 0.06)
      border: 1px solid rgba(40, 122, 237, 0.30)
      border-radius: 14px

      &__ic
        font-size: 20px
        color: $blue
        margin-top: 2px
        flex-shrink: 0

      &__txt
        display: flex
        flex-direction: column
        gap: 4px
        strong
          font-family: $display
          font-size: 17px
          font-weight: 700
          color: $ink
        span
          font-size: 14px
          line-height: 1.5
          color: $muted

    // ---------- AÇÃO + AVISOS ----------
    .cf-stage
      display: flex
      flex-direction: column
      align-items: center
      gap: 14px

      &__error
        display: inline-flex
        align-items: center
        gap: 9px
        margin: 0
        max-width: 520px
        text-align: center
        padding: 12px 18px
        border-radius: 12px
        background: rgba(221, 52, 52, 0.08)
        border: 1px solid rgba(221, 52, 52, 0.35)
        color: $red-dark
        font-size: 14px
        font-weight: 600
        &-ic
          flex-shrink: 0

    // ---------- ENCERRAR POR NOCAUTE / WO ----------
    .cf-kowo
      display: flex
      flex-direction: column
      align-items: center
      gap: 14px
      margin-top: 8px
      &__toggle
        background: none
        border: 1px dashed rgba(11, 14, 20, 0.28)
        border-radius: 999px
        padding: 8px 18px
        font-family: $display
        font-weight: 700
        font-size: 14px
        color: $muted
        cursor: pointer
        display: inline-flex
        align-items: center
        gap: 8px
        &:hover
          color: $ink
          border-color: $ink
      &__body
        display: flex
        flex-direction: column
        align-items: center
        gap: 12px
        width: 100%
        max-width: 520px
        padding: 16px
        border: 1px solid $line
        border-radius: 14px
        background: $paper
      &__hint
        margin: 0
        font-size: 13px
        color: $muted
        text-align: center
      &__row
        display: flex
        align-items: center
        gap: 10px
        flex-wrap: wrap
        justify-content: center
      &__row-label
        font-family: $mono
        font-size: 11px
        text-transform: uppercase
        letter-spacing: 0.1em
        font-weight: 700
        color: $ink
        min-width: 64px

    // ---------- CONTADORES ----------
    // Sempre lado a lado (azul esquerda / vermelho direita, como na arena):
    // no celular o juiz toca nos dois em tempo real; empilhar tiraria um
    // deles da tela no meio da luta.
    .cf-counters
      display: grid
      grid-template-columns: 1fr 1fr
      gap: 16px
      @media (max-width: 520px)
        gap: 10px

    .cf-counter
      display: flex
      flex-direction: column
      align-items: center
      justify-content: center
      gap: 6px
      min-height: 220px
      border: none
      border-radius: 18px
      cursor: pointer
      color: #fff
      user-select: none
      touch-action: manipulation // sem atraso/zoom de duplo-toque em taps rápidos
      -webkit-tap-highlight-color: transparent
      transition: transform .12s ease, box-shadow .18s ease, filter .18s ease
      @media (max-width: 520px)
        min-height: 190px
      &:hover
        filter: brightness(1.05)
      &:active
        transform: scale(.98)
      &--blue
        background: linear-gradient(160deg, #3A8CF5, $blue-dark)
        box-shadow: 0 16px 34px rgba(40, 122, 237, 0.34)
      &--red
        background: linear-gradient(160deg, #E64B4B, $red-dark)
        box-shadow: 0 16px 34px rgba(221, 52, 52, 0.34)

      &__label
        font-family: $mono
        text-transform: uppercase
        letter-spacing: 0.12em
        font-size: 12px
        font-weight: 700
        opacity: 0.9

      &__value
        font-family: $display
        font-weight: 800
        font-size: 88px
        line-height: 1
        text-shadow: 0 4px 16px rgba(0, 0, 0, 0.25)
        @media (max-width: 520px)
          font-size: 64px

      &__hint
        display: inline-flex
        align-items: center
        gap: 7px
        font-size: 12px
        font-weight: 600
        opacity: 0.85

    // ---------- PONTUAÇÃO DOS JUÍZES ----------
    .cf-scores
      background: $paper
      border: 1px solid $line
      border-radius: 18px
      padding: 24px
      box-shadow: 0 12px 30px rgba(11, 14, 20, 0.06)

      &__title
        font-family: $display
        text-transform: uppercase
        font-weight: 700
        font-size: 22px
        margin: 0 0 18px

      &__grid
        display: grid
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr))
        gap: 14px
        margin-bottom: 22px

    .cf-judge
      border: 1px solid $line
      border-radius: 14px
      padding: 14px 16px
      background: #FbFcFe

      &__name
        display: flex
        align-items: center
        gap: 8px
        font-family: $display
        font-weight: 700
        font-size: 17px
        margin-bottom: 12px
        &-ic
          color: $muted
          font-size: 14px

      &__grid
        display: grid
        grid-template-columns: 1fr 1fr
        gap: 8px

      &__cell
        display: flex
        flex-direction: column
        gap: 2px
        padding: 8px 10px
        border-radius: 9px
        background: $mist
        &--blue
          background: rgba(40, 122, 237, 0.08)
          .cf-judge__v
            color: $blue-dark
        &--red
          background: rgba(221, 52, 52, 0.08)
          .cf-judge__v
            color: $red-dark

      &__k
        font-family: $mono
        font-size: 9px
        text-transform: uppercase
        letter-spacing: 0.06em
        color: $muted

      &__v
        font-family: $display
        font-size: 22px
        font-weight: 800
        line-height: 1

    // ---------- TOTAIS ----------
    .cf-totals
      display: grid
      grid-template-columns: 1fr 1fr
      gap: 16px
      @media (max-width: 520px)
        grid-template-columns: 1fr

    .cf-total
      position: relative
      display: flex
      flex-direction: column
      align-items: center
      gap: 6px
      padding: 22px 16px
      border-radius: 14px
      border: 1px solid $line
      background: $paper
      transition: box-shadow .2s ease, border-color .2s ease, transform .2s ease
      &--blue
        border-left: 4px solid $blue
      &--red
        border-left: 4px solid $red
      &.value--winner
        border-color: $gold
        background: linear-gradient(180deg, #FFFDF6, #FFF6DE)
        box-shadow: 0 10px 26px rgba(249, 168, 37, 0.24)
        transform: translateY(-2px)

      &__crown
        position: absolute
        top: -12px
        color: $gold
        font-size: 22px
        filter: drop-shadow(0 2px 4px rgba(249, 168, 37, 0.5))

      &__label
        font-family: $mono
        font-size: 11px
        text-transform: uppercase
        letter-spacing: 0.06em
        color: $muted
        text-align: center

      &__value
        font-family: $display
        font-weight: 800
        font-size: 52px
        line-height: 1
        color: $ink

    // ---------- DESEMPATE ----------
    .cf-tie
      display: flex
      flex-direction: column
      align-items: center
      gap: 18px
      padding: 28px 24px
      border-radius: 18px
      background: linear-gradient(180deg, #FFFDF6, #FFF6DE)
      border: 1px solid rgba(249, 168, 37, 0.55)
      box-shadow: 0 12px 30px rgba(249, 168, 37, 0.18)

      &__title
        display: inline-flex
        align-items: center
        gap: 10px
        margin: 0
        font-family: $display
        font-weight: 700
        font-size: 20px
        text-align: center
        color: #7A5C00
        &-ic
          color: $gold

      &__robots
        display: flex
        flex-wrap: wrap
        justify-content: center
        gap: 16px

    // ---------- BOTÕES ----------
    .btn
      display: inline-flex
      align-items: center
      justify-content: center
      gap: 10px
      border: none
      cursor: pointer
      font-family: $display
      font-weight: 700
      text-transform: uppercase
      letter-spacing: 0.04em
      font-size: 16px
      padding: 0 26px
      height: 50px
      border-radius: 12px
      color: #fff
      touch-action: manipulation
      -webkit-tap-highlight-color: transparent
      transition: transform .18s ease, box-shadow .18s ease, filter .18s ease
      &__ic
        font-size: 14px
      &--big
        height: 56px
        font-size: 19px
        padding: 0 40px
      &--solid
        background: linear-gradient(140deg, $blue, $blue-dark)
        box-shadow: 0 12px 26px rgba(40, 122, 237, 0.34)
        &:hover
          transform: translateY(-2px)
          filter: brightness(1.05)
          box-shadow: 0 16px 32px rgba(40, 122, 237, 0.44)
      &--blue-solid
        background: linear-gradient(140deg, #3A8CF5, $blue-dark)
        box-shadow: 0 10px 24px rgba(40, 122, 237, 0.32)
        &:hover
          transform: translateY(-2px)
          filter: brightness(1.05)
      &--red-solid
        background: linear-gradient(140deg, #E64B4B, $red-dark)
        box-shadow: 0 10px 24px rgba(221, 52, 52, 0.32)
        &:hover
          transform: translateY(-2px)
          filter: brightness(1.05)

    // ---------- MOBILE (juiz de combate julga pelo celular) ----------
    // Reordena o corpo: contadores primeiro (é neles que o juiz toca o tempo
    // todo), aviso e botão de ação em seguida; o confronto desce — o juiz
    // olha pra arena, não pras fotos dos robôs.
    @media (max-width: 640px)
      &__hero
        padding: 20px 0 26px
      &__wrap
        padding: 18px 14px 56px
        gap: 16px
      .cf-counters
        order: -3
      .cf-info
        order: -2
      .cf-stage
        order: -1

  @keyframes cf-rise
    from
      opacity: 0
      transform: translateY(14px)
    to
      opacity: 1
      transform: translateY(0)

  @keyframes cf-pulse
    0%
      box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.6)
    70%
      box-shadow: 0 0 0 8px rgba(255, 107, 107, 0)
    100%
      box-shadow: 0 0 0 0 rgba(255, 107, 107, 0)
</style>
